import { showroomHours } from "@/mocks/showroomData";

export default function ShowroomVisit() {
  return (
    <section id="visit" className="w-full bg-[#F7F5F2] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="mb-14 md:mb-18">
          <p
            className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            / Plan Your Visit
          </p>
          <h2
            className="text-3xl md:text-4xl lg:text-[52px] font-extrabold text-[#1A1C1E] leading-[1.06] tracking-[-0.02em]"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Come See It
            <br />
            <span className="text-[#6C7278] font-light">in Person.</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-px bg-[#E2DED9]">
          {/* Map */}
          <div className="flex-1 min-h-[420px] lg:min-h-[560px] overflow-hidden">
            <iframe
              title="FORM Chicago Showroom"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.3!2d-87.6476!3d41.8842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e2cb9e5a5a5a5%3A0x0!2s820+W+Randolph+St%2C+Chicago%2C+IL+60607!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "420px", filter: "grayscale(30%) contrast(1.05) sepia(10%)" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info panel */}
          <div className="w-full lg:w-[400px] flex-shrink-0 bg-[#F7F5F2] p-8 md:p-12 flex flex-col gap-8">
            {/* Address */}
            <div>
              <p
                className="text-[10px] uppercase tracking-[0.22em] text-[#6C7278] mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Address
              </p>
              <p
                className="text-lg font-bold text-[#1A1C1E] leading-snug"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                820 W. Randolph Street
              </p>
              <p
                className="text-sm text-[#6C7278] mt-1"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                West Loop, Chicago, IL 60607
              </p>
              <a
                href="https://maps.google.com/?q=820+W+Randolph+St+Chicago+IL"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-1.5 mt-3 text-[12px] text-[#B8422E] hover:text-[#9E3826] transition-colors"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Get Directions <i className="ri-external-link-line" />
              </a>
            </div>

            <div className="h-px bg-[#E2DED9]" />

            {/* Hours */}
            <div>
              <p
                className="text-[10px] uppercase tracking-[0.22em] text-[#6C7278] mb-4"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Showroom Hours
              </p>
              <div className="flex flex-col gap-3">
                {showroomHours.map((h) => (
                  <div key={h.day} className="flex items-center justify-between gap-4">
                    <p
                      className="text-sm text-[#1A1C1E]"
                      style={{ fontFamily: "'Public Sans', sans-serif" }}
                    >
                      {h.day}
                    </p>
                    <p
                      className="text-sm text-[#6C7278] whitespace-nowrap"
                      style={{ fontFamily: "'Public Sans', sans-serif" }}
                    >
                      {h.time}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="h-px bg-[#E2DED9]" />

            {/* Contact */}
            <div>
              <p
                className="text-[10px] uppercase tracking-[0.22em] text-[#6C7278] mb-4"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Contact
              </p>
              <a
                href="tel:+13125550192"
                className="flex items-center gap-2.5 text-sm text-[#1A1C1E] hover:text-[#B8422E] transition-colors mb-3"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-phone-line text-[#B8422E]" />
                </div>
                (312) 555-0192
              </a>
              <a
                href="mailto:hello@formchicago.com"
                className="flex items-center gap-2.5 text-sm text-[#1A1C1E] hover:text-[#B8422E] transition-colors"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-mail-line text-[#B8422E]" />
                </div>
                hello@formchicago.com
              </a>
            </div>

            {/* CTA */}
            <a
              href="tel:+13125550192"
              className="inline-flex items-center justify-center gap-2 w-full py-4 bg-[#1A1C1E] text-white text-[12px] font-semibold hover:bg-[#B8422E] transition-colors duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              <i className="ri-calendar-line" />
              Book a Design Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
